import dashboardData from '../../../../data/dashboard/dashboardData.json';
import MarketplaceCards from './sections/MarketplaceCards';
import InTripUtilities from './sections/InTripUtilities';

const TravellerAppFeatures = () => {
  const marketplaces = dashboardData.travellerAppFeatures?.marketplaces || [];
  const utilities = dashboardData.travellerAppFeatures?.utilities || [];

  return (
    <div
      data-tour="traveller-app-features"
      className="w-full bg-white rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-7 xl:p-8 border border-slate-100 shadow-sm hover:shadow-md transition-all duration-300"
    >
      {/* Header */}
      <div>
        <h2 className="text-lg sm:text-xl md:text-2xl font-normal text-slate-800 tracking-tight leading-snug">
          What your traveller gets in your app
        </h2>
        <p className="text-xs sm:text-sm text-slate-500 mt-1 font-normal leading-relaxed">
          Three curated on-ground categories, plus essential utilities for a seamless journey.
        </p>
      </div>

      {/* 3 Marketplace Cards Section */}
      <MarketplaceCards marketplaces={marketplaces} />

      {/* Essential In-Trip Utilities Section */}
      <InTripUtilities utilities={utilities} />
    </div>
  );
};

export default TravellerAppFeatures;
